<div class="card-header d-flex p-1"><span class="flex-grow-1 p-1">{{title}}<ng-content select="extra-title"></ng-content></span>
    <ng-content select="extra-buttons"></ng-content>
</div>